import React from "react";
import { ReportCard } from "../../Admin/Reports/ReportCard";
import "../../Admin/Reports/Reports.css";
import UserActivityReports from "../../../assets/Icons/SuperAdmin _ Reports/user activity report.svg";
import OrgUserStatistics from "../../../assets/Icons/SuperAdmin _ Reports/Organization User Statistics.svg";
import OrgBookSummaryIcon from "../../../assets/Icons/SuperAdmin _ Reports/Organization Book Summary.svg";
import EmployeeSequentialProgressIcon from "../../../assets/Icons/SuperAdmin _ Reports/Organization User Activity .svg";
import PromotionsOutline from "../../../assets/promotions/promotions-outline.svg";

const reportData = [
  {
    _id: 5,
    icon: UserActivityReports,
    label: 'Employee Activity',
    link: 'employee-activity',
    description:
      'Cross-company employee report with company, role, org books completed, points earned and redeemed, balance, time trials, and last login. Active means at least one org or company book completed in the last two months.',
  },
  {
    _id: 6,
    icon: OrgUserStatistics,
    label: 'Company Wise Breakdown',
    link: 'company-wise-breakdown',
    description:
      'Per-company totals for employees, active and inactive users, points earned and redeemed, balance, and admin counts. Active means at least one org or company book completed in the last two months.',
  },
  {
    _id: 7,
    icon: OrgBookSummaryIcon,
    label: 'Org Book Summary',
    link: 'org-book-summary',
    description:
      'Published organisation books in sequence with eligible, completed, ongoing, and locked user counts across all companies.',
  },
  {
    _id: 8,
    icon: EmployeeSequentialProgressIcon,
    label: 'Employee Sequential Progress',
    link: 'employee-sequential-progress',
    description:
      'Where each employee is in the organisation book journey, with task progress, status, and waiting-since dates.',
  },
  {
    _id: 9,
    icon: PromotionsOutline,
    label: 'Promotions',
    link: 'promotions',
    description:
      'Eligible employees by organisation book with contact, response, and promotion completion status across the lifecycle.',
  },
];

export const SaReports = () => {
  return (
    <div className="container">
      <div className="reports">
        {reportData.map((elm) => (
          <ReportCard key={elm._id} base={"/super-admin/reports"} data={elm} />
        ))}
      </div>
    </div>
  );
};
